export default __webpack_public_path__ + "static/Carousel-Grouping@2x-41bcb3c6cbd8d93eda12b607bb05d86d.png";